export default __webpack_public_path__ + "resources/icons/n440-afe9.png";